/**
 * Single-volume exclusion endpoints require ?accounts=<child-uuid> in org context.
 * Do not use accounts=all here (API returns 400). See DT-8988 handoff.
 */
export function buildVolumeExclusionsUrl(volumeId: string, accountId?: string): string {
  const params = new URLSearchParams();
  if (accountId) {
    params.set('accounts', accountId);
  }
  const query = params.size ? `?${params.toString()}` : '';
  return `/api/v1/volumes/${volumeId}/autoscaling/rules/exclusions${query}`;
}
